import {
  apiGet,
  apiPut,
  apiDelete,
  apiPost,
} from "../../../utils";

export const getShipManagementDetailsAPI = (data) => {
  return apiGet("/api/ship-management", data);
};  

export const addShipManagementDetailsAPI = (data) => {
  return apiPost("/api/ship-management", data);
};

export const updateShipManagementDetailsAPI = (params, data) => {
  return apiPut(`/api/ship-management/${params.id}`, data);
};

export const deleteShipManagementDetailsAPI = (id) => {
  return apiDelete(`/api/ship-management/${id}`);
};